/**
 * SchedulesSummaryWidget — appointment counts per day for the next 14 days.
 * Uses BarChartCard (Recharts wrapper) with a short MMM-D label per bar.
 */

import * as React from "react";
import { BarChartCard, WidgetCard } from "components/dashboard";
import { useSchedulesSummary, formatQueryError } from "../hooks";
import type { LayoutItem, WidgetConfig } from "../types";

interface Props {
  widget: WidgetConfig;
  layout: LayoutItem;
}

function shortDate(iso: string): string {
  const [, m, d] = iso.split("-").map(Number);
  if (!m || !d) return iso;
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${months[m - 1]} ${d}`;
}

export function SchedulesSummaryWidget({ widget, layout }: Props) {
  const { data, isLoading, error } = useSchedulesSummary(14);
  const chartData = (data?.days ?? []).map((d) => ({ label: shortDate(d.date), value: d.count }));

  return (
    <WidgetCard
      title={widget.title}
      w={widget.defaultSize.w}
      h={widget.defaultSize.h}
      x={layout.x}
      y={layout.y}
      loading={isLoading}
      error={error ? formatQueryError(error) : null}
    >
      <BarChartCard data={chartData} barColor="#2563eb" height={100} />
    </WidgetCard>
  );
}
